import React, { Dispatch, ReactFragment, SetStateAction } from 'react';

import mergeTokens from '@amzn/meridian-tokens/base/icon/merge';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';

import { isNil } from 'lodash';
import { formatDate } from 'src/components/CompareContracts/TimestampPicker/TimestampPicker';

export interface ISearchResultTable {
    results: SelectionRow[];
    setContractId: Dispatch<SetStateAction<string | undefined>>;
}

export interface SelectionRow {
    contractId: number;
    serviceId: number;
    startDate: Date;
    endDate?: Date;
    rowId: number;
    contractName: string;
    entityName: string;
    serviceName: string;
    entityId: string;
}

const TABLE_CONFIG: { name: string; renderer: (interval: SelectionRow) => ReactFragment }[] = [
    { name: 'Label Name', renderer: (interval) => interval.entityName },
    { name: 'Contract Name', renderer: (interval) => interval.contractName },
    { name: 'Service Name', renderer: (interval) => interval.serviceName },
    { name: 'Start Date', renderer: (interval) => formatDate(interval.startDate) },
    { name: 'End Date', renderer: (interval) => (isNil(interval.endDate) ? '' : formatDate(interval.endDate)) }
];

export const SearchResultTable: React.FC<ISearchResultTable> = (props) => {
    const { results } = props;

    // TODO: use a <Responsive /> element to adjust maxHeight
    return (
        <Column height={'40rem'} overflowY={'scroll'}>
            <Table
                headerRows={1}
                fixHeaderRows={true}
                showDividers={true}
                showStripes={results.length > 3}
                spacing={'small'}
            >
                <TableRow>
                    <TableCell />
                    {TABLE_CONFIG.map((config) => (
                        <TableCell key={config.name}>{config.name}</TableCell>
                    ))}
                </TableRow>
                {results.map((option) => (
                    <TableRow key={option.rowId}>
                        <TableCell>
                            <Button
                                aria-label={`use-contract-${option.contractId}`}
                                onClick={() => props.setContractId(`${option.contractId}`)}
                                size={'small'}
                            >
                                <Icon tokens={mergeTokens} />
                            </Button>
                        </TableCell>
                        {TABLE_CONFIG.map((config) => (
                            <TableCell key={config.name}>{config.renderer(option)}</TableCell>
                        ))}
                    </TableRow>
                ))}
            </Table>
        </Column>
    );
};
